import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Link } from "react-router";
import { Layout, Menu, Icon, Affix } from "antd";
import modules from "modules";
import configurations from "../../config/configurations";

const actions = modules.actions.auth;
const SubMenu = Menu.SubMenu;

import "./CoreLayout.scss";

class CoreLayout extends React.Component {
  state = {
    collapsed: false,
  };

  _toggle = () => {
    console.log("Toggle");
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  _logout = () => {
    this.props.signout();
    this.props.router.replace("/auth");
  };

  render() {
    const { collapsed } = this.state;
    const {
      content,
      statusBar,
      toolbarFilters,
      routes,
      location,
      signout,
      user,
    } = this.props;
    const title = routes[1] && routes[1].title ? routes[1].title : false;

    const hasAllAccess =
      user.authorities && user.authorities.includes("ROLE_ALL_VIEW");

    const hasAlertsAccess =
      user.authorities && !user.authorities.includes("ROLE_ALERT_DISABLED");

    const hasActionPlansAccess =
      user.authorities &&
      !user.authorities.includes("ROLE_ACTION_PLAN_DISABLED");

    const hasSocialMediaAccess =
      user.authorities &&
      !user.authorities.includes("ROLE_SOCIAL_MEDIA_DISABLED");

    const hasDashboardAccess =
      /*user.authorities.includes("ROLE_DASHBOARD_VIEW") &&*/
      user.authorities && !user.authorities.includes("ROLE_DASHBOARD_DISABLED");

    const hasReportsAccess =
      /*user.authorities.includes("ROLE_REPORT_VIEW") &&*/
      user.authorities && !user.authorities.includes("ROLE_REPORT_DISABLED");

    const hasCoCreationAccess =
      user.externalRole !== "GERENTE_AREA" &&
      user.externalRole !== "RESTAURANTE" &&
      user.authorities &&
      !user.authorities.includes("ROLE_COCREACION_DISABLED");

    const logoStyle = configurations[0].layout.logoDashboard.style;

    return (
      <Layout className="main-layout">
        <Layout.Sider
          className="sider"
          breakpoint="lg"
          collapsedWidth="64"
          collapsed={collapsed}
          collapsible
          trigger={null}
          onBreakpoint={(broken) => this.setState({ collapsed: broken })}
        >
          <Layout.Header className="main-header flex flex-horizontal">
            <div className="main-logo" style={logoStyle} />
            <Icon
              className="trigger"
              type={collapsed ? "menu-unfold" : "menu-fold"}
              onClick={this._toggle}
            />
            <div className="flex-1" />
          </Layout.Header>

          <Menu
            theme="dark"
            defaultOpenKeys={[
              location.pathname.indexOf("alerts") > -1 ? "/alerts/stats" : "",
            ]}
            selectedKeys={[location.pathname]}
            mode="inline"
            className="main-menu"
          >
            {hasDashboardAccess ? (
              <Menu.Item key="/">
                <Link to={"/"}>
                  <i className="icon-graph" />
                  <span>Dashboard</span>
                </Link>
              </Menu.Item>
            ) : null}

            {hasAlertsAccess ? (
              <SubMenu
                key="/alerts"
                title={
                  <span className="sub-menu-name">
                    <i className="icon-bullhorn" />
                    <span>Alertas</span>
                  </span>
                }
              >
                <Menu.Item key="/alerts/stats">
                  <Link to="/alerts/stats">Estadisticas</Link>
                </Menu.Item>
                <Menu.Item key="/alerts/detail">
                  <Link to="/alerts/detail">Detalle</Link>
                </Menu.Item>
              </SubMenu>
            ) : null}

            {false && hasActionPlansAccess ? (
              <Menu.Item key="/action-plans/stats">
                <Link to="/action-plans/stats">
                  <i className="icon-group-work" />
                  <span>Planes de acción</span>
                </Link>
              </Menu.Item>
            ) : null}

            {/*hasAccess ? (
              <Menu.Item key="/social">
                <Link>
                  <i className="icon-network" />
                  <span>Social Listening</span>
                </Link>
              </Menu.Item>
            ) : null*/}

            {hasReportsAccess ? (
              <Menu.Item key="/reports">
                <Link to={"/reports"}>
                  <i className="icon-file-charts" />
                  <span>Reportes</span>
                </Link>
              </Menu.Item>
            ) : null}

            {false && hasCoCreationAccess ? (
              <Menu.Item key="/cocreation">
                <Link to="/cocreation">
                  <i className="icon-chart-settings" />
                  <span>Co Creacion</span>
                </Link>
              </Menu.Item>
            ) : null}

            {false && hasSocialMediaAccess ? (
              <Menu.Item key="social-media">
                <Link to="/social">
                  <i className="icon-radar" />
                  <span>Social Media</span>
                </Link>
              </Menu.Item>
            ) : null}
          </Menu>

          <div className="flex-1" />

          <Menu
            theme="dark"
            mode="inline"
            className="main-menu"
            onClick={this._logout}
          >
            <Menu.Item key="-1">
              <i className="icon-exit-right" />
              <span>Logout</span>
            </Menu.Item>
          </Menu>

          <div className="legals">
            <span>{__APP_NAME__}</span>

            <span>{__VERSION__}</span>
          </div>
        </Layout.Sider>
        <Layout
          className={classnames("main-content", {
            "sider-collapsed": collapsed,
          })}
        >
          <Affix>
            <Layout.Header className="flex flex-horizontal">
              <div>
                <Icon
                  className="trigger"
                  type={collapsed ? "menu-unfold" : "menu-fold"}
                  onClick={this._toggle}
                />
                <span className="main-title">{title}</span>
              </div>
              <div className="flex-1" />
              <div className="user-info">
                <div className="user-info">
                  {user && (
                    <span className="name">
                      {user.firstName} {user.lastName}
                    </span>
                  )}
                  {user && <span className="username">{user.login}</span>}
                </div>
                {/* <span>demo@limetropy.com</span> */}
              </div>
            </Layout.Header>
          </Affix>
          <Layout.Content style={{ display: "flex", flexDirection: "column" }}>
            {statusBar && (
              <Affix offset={60}>
                <div className="status-bar-container">{statusBar}</div>
              </Affix>
            )}
            {toolbarFilters && <div className="">{toolbarFilters}</div>}
            {content}
          </Layout.Content>
        </Layout>
      </Layout>
    );
  }
}

CoreLayout.propTypes = {
  content: PropTypes.node,
  statusBar: PropTypes.node,
};

const mapDispatchToProps = (dispatch) => {
  return {
    signout: () => dispatch(actions.signout()),
  };
};

const mapStateToProps = ({ user }) => ({
  user: user.data,
});

export default connect(mapStateToProps, mapDispatchToProps)(CoreLayout);



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/CoreLayout.jsx